import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTakeTemplateAddPage } from './klmr-take-template-add';

@NgModule({
  declarations: [
    KlmrTakeTemplateAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTakeTemplateAddPage),
  ],
})
export class KlmrTakeTemplateAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-take-template-add/klmr-take-template-add.module.ts